// import styles
import '../scss/main.scss';

// application imports
import $ from 'jquery';
import {App} from './app.ts';

// load ie polyfills
import 'url-polyfill';

// initialize the app
$(function () {
    'use strict';
    console.debug('main: initializing Ideenwerkstatt ...');

    try {
        new App().init().then(() =>
            console.debug('main: Ideenwerkstatt successfully initialized'));

    } catch (err) {
        console.error("main: Ideenwerkstatt failed to initialize", err);
    }
});
